import type { FC } from "react";
import { CalculatorNote } from "web_myplann/Calculators/Components/CalculatorNote";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	hasRates: boolean;
	isOfferMissing: boolean;
};

export const CalculatorRatesNote: FC<Props> = ({
	hasRates,
	isOfferMissing,
}) => {
	const { t } = useResource();

	if (!hasRates) {
		return (
			<CalculatorNote text={t(Resources.Calculators.Result.RatesUnavailable)} />
		);
	}

	if (isOfferMissing) {
		return <CalculatorNote text={t(Resources.Calculators.Result.NoOffer)} />;
	}

	return null;
};
